import React from 'react';
import { Tabs, Row, Col } from 'antd';
import { useParams } from 'react-router-dom';
import OfficesTab from 'modules/companies/components/CompanyDetails/OfficesTab';
import UsersTab from './UsersTab';
import { useQuery } from 'react-query';
import companiesAdminApi from 'services/companiesAdmin';
import { BsFillPhoneFill } from 'react-icons/bs';
import { IoIosMail } from 'react-icons/io';
import { ReactComponent as LocationIcon } from 'resources/icons/geo-alt-fill.svg';
import BreadCrumb from 'components/breadcrumb/BreadCrumb';
import Footer from 'components/layouts/footer/Foot';

const { TabPane } = Tabs;

const CompanyDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  // Per-request x-tenant-id is handled inside UsersTab and OfficesTab; no global overrides here.

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <BreadCrumb />
        </Col>
      </Row>
      <div className="table-container">
        {/* <p className="pg-heading">Company Details</p> */}

        <CompanyInfoHeader companyId={id!} />

        <Tabs defaultActiveKey="users">
          <TabPane tab="Users" key="users">
            <UsersTab />
          </TabPane>
          <TabPane tab="Offices" key="offices">
            <OfficesTab />
          </TabPane>
        </Tabs>
      </div>
      <Row>
        <Col span={24}>
          <Footer />
        </Col>
      </Row>
    </>
  );
};

export default CompanyDetails;

const CompanyInfoHeader: React.FC<{ companyId: string }> = ({ companyId }) => {
  const { data } = useQuery(['adminCompany', companyId], () => companiesAdminApi.getCompanyById(companyId));
  const company = data?.data || {};

  return (
    <Row>
      <Col span={24}>
        <div className="companyContainer">
          <Row>
            <Col span={10}>
              <div className="OfficeNameInfoWarpper">
                <div className="officeInfo">
                  <p className="comapnyName">{company?.name}</p>
                  <p className="usdot">USDOT Number: {company?.usdot}</p>
                </div>
              </div>
            </Col>
            <Col span={14}>
              <div className="companyContactInfo">
                <div className="hrline" />
                <Row>
                  <div className="contactIcons">
                    <Col span={8}>
                      <div className="iconWarpper">
                        <div>
                          <BsFillPhoneFill size={20} className="Icon" />
                        </div>
                        <span className="contactIconText">{company?.phoneNumber}</span>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div className="iconWarpper">
                        <div>
                          <IoIosMail size={25} className="Icon" />
                        </div>
                        <span className="contactIconText">{company?.email}</span>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div className="iconWarpper">
                        <div>
                          <LocationIcon width={20} height={20} className="Icon" />
                        </div>
                        <span className="contactIconText">{company?.address}</span>
                      </div>
                    </Col>
                  </div>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};
